import { Box, Divider, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { FamilyList } from "./FamilyList";
import FormFamilyGroup from "./FormFamilyGroup";
import { TutoresList } from "./TutoresList";
import useFamilyGroupLoader from "../hooks/useFamilyGroupLoader";

export const FamilyView = () => {
  const {
    familyGroup,
    payloadToken,
    removeFamilyMember,
    loadFamilyGroup,
    tutoresGroup,
  } = useFamilyGroupLoader();

  return (
    <Box
      style={{
        backgroundColor: "#fff",
        padding: 10,
        borderRadius: 10,
      }}
    >
      <Typography color={grey[700]} fontWeight={700} fontSize={24} pt={2}>
        GESTIONE SU GRUPO FAMILIAR
      </Typography>
      <Typography color={grey[400]} fontWeight={700} fontSize={12} pb={2}>
        ADMINISTRE LOS INTEGRANTES DE SU GRUPO FAMILIAR
      </Typography>
      <Stack spacing={2} mb={2} mt={2}>
        <FamilyList
          familyGroup={familyGroup}
          payloadToken={payloadToken}
          removeFamilyMember={removeFamilyMember}
        />
        <Divider />
        <FormFamilyGroup loadFamilyGroup={loadFamilyGroup} />
        <Divider />
        <TutoresList
          tutoresGroup={tutoresGroup}
          payloadToken={payloadToken}
          removeFamilyMember={removeFamilyMember}
        />
      </Stack>
    </Box>
  );
};
